/* eslint-disable jsx-a11y/iframe-has-title */
import { useEffect, useState } from "react";
import "../../../../App.css";
import {
  formatDate,
  formatDateYear,
  getDay,
  addHour,
  isPastDate,
} from "../../../../services/formateDate";
import { MdPeopleAlt } from "react-icons/md";

import {
  IconBuilding,
  IconSchool,
  IconStar,
  IconBriefcase,
  IconUser,
  IconCalendar,
  IconHistory,
  IconActivity,
} from "@tabler/icons-react";
import ReportTable from "./ReportTable";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import OpenEmail from "./OpenEmail";
import AreaMap from "./AreaMap";
import ThankYou from "./ThankYou";
import { base_url, razorpay_key } from "../../../../config";

const predefinedTags = {
  Beginners: {
    icon: <IconStar size={24} color="#e2b760" />, // Replace color with your theme
    description: "Perfect for those just starting their journey.",
  },
  Experts: {
    icon: <IconBriefcase size={24} color="#e2b760" />,
    description: "Designed for seasoned professionals.",
  },
  Regional: {
    icon: <IconBuilding size={24} color="#e2b760" />,
    description: "Focuses on regional topics and insights.",
  },
  Business: {
    icon: <IconBriefcase size={24} color="#e2b760" />,
    description: "Targeted at business professionals.",
  },
  Corporate: {
    icon: <IconUser size={24} color="#e2b760" />,
    description: "Corporate-level expertise and collaboration.",
  },
  Celebrity: {
    icon: <IconStar size={24} color="#e2b760" />,
    description: "Insights from the world of celebrities.",
  },
  Festival: {
    icon: <IconCalendar size={24} color="#e2b760" />,
    description: "Celebrate cultural and artistic festivals.",
  },
  Student: {
    icon: <IconSchool size={24} color="#e2b760" />,
    description: "Ideal for students seeking knowledge.",
  },
  Active: {
    icon: <IconActivity size={24} color="#e2b760" />,
    description: "Engage in active learning and growth.",
  },
  History: {
    icon: <IconHistory size={24} color="#e2b760" />,
    description: "Dive into historical events and trends.",
  },
};

const RAZORPAY_KEY_ID = razorpay_key // Replace with your actual key


const ListeningDetails = ({
  data,
  setIsModalOpen,
  setLoginModal,
  open,
  bookPage,
  setBookPage,
  loginData,
}) => {
  const userId = localStorage.getItem("@userAccount");
  const token = localStorage.getItem("@user");
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");
  const tname = searchParams.get("table");
  const userPhone = localStorage.getItem("@userPhone");

  const disableBooking = isPastDate(formatDateYear(data?.event_date));

  const [isBooked, setIsBooked] = useState(false);
  const [isPayed, setIsPayed] = useState(false);
  const [userName, setUserName] = useState(
    localStorage.getItem("@userName") || ""
  );
  const [email, setEmail] = useState(localStorage.getItem("email") || "");
  const [age, setAge] = useState(localStorage.getItem("age") || "");
  const [gender, setGender] = useState(localStorage.getItem("gender") || "");
  const [thanksModal, setThanksModal] = useState(false);
  const [cancellationAvailable, setCancellationAvailable] = useState(isCancellationAvailable(data?.event_date));
  const [showCancellation, setShowCancellation] = useState(false);

  const [oldOrderId, setOldOrderId] = useState(data?.order_id);

  const tagsArray = data?.tags?.split(",").map((tag) => tag.trim());
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  const [showModal, setShowModal] = useState(false);
  const [showCouponModal, setShowCouponModal] = useState(false);
  const [couponCode, setCouponCode] = useState('');
  const [couponError, setCouponError] = useState('');
  const [couponLoading, setCouponLoading] = useState(false);
  const [appliedCoupon, setAppliedCoupon] = useState(null);
  const [discountedPrice, setDiscountedPrice] = useState(null);

  const handlePayment = async (order_id) => {
    // If 100% discount is applied, skip payment and proceed directly
    if (discountedPrice === 0) {
      handleCheckPayment('FREE_COUPON_BOOKING');
      return;
    }

    // alert(`order_id: ${data?.order_id}`);

    // ReactPixel.track('InitiateCheckout', { value: data?.price, currency: 'INR' });

    if (
      (!localStorage.getItem("email") && accessToken) ||
      (!localStorage.getItem("@userName") && accessToken)
    ) {
      setShowModal(true);
      return;
    }
    const options = {
      key: RAZORPAY_KEY_ID, // Razorpay key ID
      amount: data?.price * 100, // Amount in paise (₹500.00)
      currency: "INR",
      name: "HighTable",
      order_id: order_id,
      description: "Transaction to book a table",
      image: "/images/High_Table_Logo.png", // Optional logo
      handler: (response) => {
        handleCheckPayment(response.razorpay_payment_id);
      },
      prefill: {
        name: userName,
        email: email,
        contact: userPhone,
        table_booking_id: order_id,
      },
      theme: {
        color: "#F37254",
      },
    };
    // eslint-disable-next-line no-undef
    const razorpay = new Razorpay(options);
    razorpay.open();

    razorpay.on("payment.failed", (response) => {
      alert(`Payment failed! Reason: ${response.error.description}`);
      console.error(response.error);
    });
    setIsPayed(true);
  };

  const validateCoupon = async () => {
    if (!couponCode.trim()) {
      setCouponError('Please enter a coupon code');
      return;
    }

    setCouponLoading(true);
    setCouponError('');

    try {
      const url = `${base_url}/table-booking/validate-coupon`;
      const body = {
        couponCode: couponCode.trim(),
        tableId: data?.id,
        userId: userId,
        phone: userPhone || ''
      };

      // Add user_type if it exists in query parameters
      const userType = searchParams.get("user_type");
      if (userType) {
        body.user_type = userType;
      }

      const response = await axios.post(url, body, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });

      if (response?.data?.data?.isValid) {
        setAppliedCoupon({
          code: couponCode.trim(),
          discount: 100
        });
        setDiscountedPrice(0); // 100% discount = price becomes 0
        setShowCouponModal(false);
        toast.success('Coupon applied successfully! 100% discount applied.', {
          position: "top-center",
        });
      } else {
        setCouponError('Invalid coupon code');
      }
    } catch (error) {
      console.error('Coupon validation error:', error);
      setCouponError(error.response?.data?.message || 'Failed to validate coupon. Please try again.');
    } finally {
      setCouponLoading(false);
    }
  };

  const removeCoupon = () => {
    setAppliedCoupon(null);
    setDiscountedPrice(null);
    setCouponCode('');
    setCouponError('');
  };

  const accessToken = localStorage.getItem("@user");

  useEffect(() => {
    if (open) {
      if (!isPayed) {
        navigate(`/details?table=${tname}&id=${id}`);
      } else if (isPayed) {
        setIsModalOpen(true);
      }
    }
  }, [accessToken]);

  const handleBookTable = async () => {
    setBookPage(false);
    if (
      (!localStorage.getItem("email") && accessToken) ||
      (!localStorage.getItem("@userName") && accessToken)
    ) {
      setShowModal(true);
      return;
    }

    const url = `${base_url}/table-booking/book-table`;
    const body = {
      table_id: data?.id,
    };

    try {
      const response = await axios.post(url, body, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      if (response?.data?.details?.order_id) {
        handlePayment(response?.data?.details?.order_id);
      }
    } catch (error) {
      console.log("=======>Error", error?.response?.data?.message);
    }
  };

  const handleCancellation = async (eventDateStr) => {
    try {
      const isValid = isCancellationAvailable(eventDateStr);

      if (!isValid) {
        setCancellationAvailable(false);
        return;
      };

      const url = `${base_url}/table-booking/cancel-booking`;
      const body = {
        amount: data?.price * 100,
        orderId: data?.order_id,
        tableId: id,
        userId: userId
      };

      const response = await axios.post(url, body, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      window.location.reload();
    } catch (error) {
      console.log('Error in handleCancellation :: ', error);
    };
  };

  function parseEventDate(dateStr) {
    const [datePart, timePart] = dateStr?.split(' ');
    const [day, month, year] = datePart?.split('-')?.map(Number);
    const [hour, minute] = timePart?.split(':')?.map(Number);
    return new Date(year, month - 1, day, hour, minute);
  };

  function isCancellationAvailable(eventDateStr) {
    const eventDate = parseEventDate(eventDateStr);
    const now = new Date();
    const diffInMs = eventDate.getTime() - now.getTime();
    const diffInHours = diffInMs / (1000 * 60 * 60);
    return diffInHours > 24;
  };

  const handleCheckPayment = async (paymentId) => {
    // Use different endpoints based on whether coupon is applied
    const url = appliedCoupon 
      ? `${base_url}/table-booking/book-table-coupon`
      : `${base_url}/table-booking/capture-payment`;
    
    // Extract booking_source from URL parameters
    const bookingSource = searchParams.get("booking_source");
    
    const body = appliedCoupon 
      ? {
          couponCode: couponCode,
          userId: userId,
          tableId: id
        }
      : {
          payment_id: paymentId
        };
    
    if (bookingSource) {
      body.booking_source = bookingSource;
    }

    try {
      const response = await axios.post(url, body, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      setIsBooked(true);
      setThanksModal(true);
    } catch (error) {
      console.log("=======>Error", error);
      toast.error("capture failed! Please try after some time!", {
        position: "top-center",
      });
    }
  };
  const navigate = useNavigate();
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY > lastScrollY && currentScrollY > 50) {
        // Scrolling down, hide navbar
        setIsVisible(false);
      } else {
        // Scrolling up, show navbar
        setIsVisible(true);
      }

      setLastScrollY(currentScrollY);
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [lastScrollY]);

  const checkId = async () => {
    if (data?.booking_status === 9 || data?.booking_status === 10) {
      setIsBooked(true);
    };
  };

  const checkPaidId = async () => {
    try {
      if (data?.booking_status !== null) {
        if (data?.booking_status !== 9 || data?.booking_status !== 10) {
          setIsPayed(true);
          setOldOrderId(data?.order_id);
        }
      }

     
    } catch (error) {
      console.error("Error checking if ID is not paid:", error.message);
    }
  };

  useEffect(() => {
    if (Number(userId) !== Number(data?.creator_details?.id)) {
      checkId();
    }
  }, []);

  useEffect(() => {
    if (Number(userId) !== Number(data?.creator_details?.id)) {
      checkPaidId();
    }
  }, []);

  useEffect(() => {
    if (bookPage === true && loginData && !isBooked) {
      console.log("=====>log in api called", loginData);

      if (data?.booking_status !== 9 || data?.booking_status !== 10) {
        console.log("=====> isPayed true", data?.order_id);
        if (data?.order_id) handlePayment(data?.order_id);
        else handleBookTable();
      } else {
        console.log("=====> isPayed false", data);
        handleBookTable();
      }
      console.log("======>book page", bookPage);
    }
  }, [data, bookPage]);

  return (
    <>
      <section className="lisiting-site-content">
        <section
          data-w-id="baa49f18-5350-fcd4-0685-c53c0b86a6fd"
          className={`book-now-btn-mob-section ${isVisible ? "translate-y-0" : "translate-y-full"
            }`}
        >
          <div className="mobile-book-btn">
            <div className="mob-book-btn-sticky">
              <div className="card-flex-block">
                <div className="night-price-text mob-text">
                  <span className="price-text mob-text-price">
                    ₹ {data?.price}{" "}
                  </span>
                  / per seat
                </div>
              </div>
              {accessToken ? (
                <>
                  {Number(userId) ===
                    Number(data?.creator_details?.id) ? null : isBooked ? (
                      <div>
                        <div
                          className="margin-top margin-small"
                          onClick={() => setIsModalOpen(true)}
                        >
                          <a className="button-2 w-button">View Your Ticket</a>
                        </div>

                        <div style={{ marginTop: '6px' }}>
                          <button
                            className="button-cancellation w-button"
                            onClick={() => {
                              if (cancellationAvailable) {
                                handleCancellation(data?.event_date);
                              }
                            }}
                            disabled={!cancellationAvailable}
                          >
                            {cancellationAvailable ? 'Cancel Booking' : 'Cancellation time over!'}
                          </button>
                        </div>

                      </div>
                    ) : data?.booking_close ? (
                      <div className="margin-top margin-small">
                        <div className="button-red  w-button-red ">Sold out</div>
                      </div>
                    ) : isPayed ? (
                      <div
                        onClick={
                          !disableBooking
                            ? () => {
                              data?.order_id
                                ? handlePayment(data?.order_id)
                                : handleBookTable();
                            }
                            : undefined
                        }
                        className="margin-top margin-small"
                      >
                        <button
                          className={`button-2 w-button ${disableBooking ? "disabled" : ""
                            }`}
                          disabled={disableBooking}
                        >
                          {disableBooking ? "Table Expired" : discountedPrice === 0 ? "Book for Free" : "Pay Now"}
                        </button>
                      </div>
                    ) : (
                    <div
                      className="margin-top margin-small"
                      onClick={!disableBooking ? handleBookTable : undefined}
                    >
                      <button
                        className={`button-2 w-button ${disableBooking ? "disabled" : ""
                          }`}
                        disabled={disableBooking}
                      >
                        {disableBooking ? "Table Expired" : discountedPrice === 0 ? "Book for Free" : "Book Now"}
                      </button>
                    </div>
                  )}
                </>
              ) : (
                <>
                  <div
                    className="margin-top margin-small"
                    onClick={
                      !disableBooking
                        ? () => {
                          setLoginModal(true);
                        }
                        : undefined
                    }
                  >
                    <button
                      className={`button-2 w-button ${disableBooking ? "disabled" : ""
                        }`}
                      disabled={disableBooking}
                    >
                      {disableBooking ? "Table Expired" : discountedPrice === 0 ? "Book for Free" : "Book Table"}
                    </button>
                  </div>
                </>
              )}
            </div>
          </div>
        </section>
        <div className="section-home-site_content">
          <div className="page-padding-2">
            <div className="container-medium-2">
              <div className="padding-vertical padding-small">
                <div className="home-site_component">
                  <div
                    data-w-id="055cdd77-ca91-c72e-3006-56f5f4b8a296"
                    className="home-site_flex-items"
                  >
                    <div className="site_left-item">
                      <div className="site_flex-block">
                        <div className="site_flex-left-content">
                          <p className="category-listing-page">
                            {data?.category?.name}
                          </p>
                          <div className="margin-bottom margin-xsmall">
                            <h2 className="heading-7">
                              Table hosted by{" "}
                              {data?.creator_details?.first_name}
                            </h2>
                          </div>
                          <div className="margin-bottom">
                            <div
                              className="text-weight-bold"
                              dangerouslySetInnerHTML={{
                                __html: data?.description,
                              }}
                            />
                          </div>
                        </div>
                        <Link
                          to={`/viewprofile?user=${data?.creator_details?.first_name}&id=${data?.creator_details?.id}`}
                          className="review-five-user hide-on-mob"
                        >
                          <img
                            src={
                              data?.creator_details?.photo
                                ? `https://s3.ap-south-1.amazonaws.com/high-table-2024/public/photo/members/${data?.creator_details?.photo}`
                                : "https://www.shutterstock.com/image-vector/social-member-vector-icon-person-260nw-1139787308.jpg"
                            }
                            loading="lazy"
                            alt=""
                            className="user-profile-pic"
                          />
                        </Link>
                      </div>
                      <div className="site_content-divider" />

                      {tagsArray.length > 1 && (
                        <div className="site_content-divider" />
                      )}

                      <>
                        <div className="site_sleep-content block md:hidden">
                          <div className="margin-bottom margin-small">
                            <h2 className="heading-7">Cancellation Policy</h2>
                          </div>
                          <div
                            onClick={() => setShowCancellation(!showCancellation)}
                            style={{
                              color: 'blue',
                              cursor: 'pointer',
                              textDecoration: 'underline',
                              marginBottom: '16px',
                              maxWidth: 'fit-content',
                            }}
                          >
                            * Cancellation Policy click here to know more...
                          </div>

                          {showCancellation && (
                            <div style={{
                              marginBottom: '16px',
                              padding: '4px',
                              border: '1px solid blue',
                              borderRadius: '4px',
                              boxShadow: '0 2px 6px rgba(37, 174, 233, 0.2)',
                              color: 'black'
                            }}>
                              <ul>
                                <li>•	Cancellations made up to 24 hours before the event: 100% refund (excluding payment transaction fee)</li>
                                <li>•	Cancellations made within 24 hours of the event: No refund</li>
                                <li>•	In case the event is cancelled by the host/venue, guests will receive a full refund (including payment transaction fee)</li>
                                <li>•	No-shows will not be eligible for a refund.</li>
                                <li>•	Refunds will be processed to the original payment method within 5–7 business days.</li>
                              </ul>
                            </div>
                          )}
                        </div>
                        <div className="site_content-divider block md:hidden" />

                        <div className="site_sleep-content">
                          <div className="margin-bottom margin-small">
                            <h2 className="heading-7">What's Included</h2>
                          </div>
                          <div className="text-weight-bold">
                            {data.inclusion ? (
                              <> {data.inclusion}</>
                            ) : (
                              <>
                                "Oops, looks like the data took a coffee break!
                                ☕ No info here right now."
                              </>
                            )}

                            <br />
                          </div>
                        </div>
                      </>
                      <div className="site_content-divider" />
                      <div className="site_sleep-content">
                        <div className="margin-bottom margin-small">
                          <h2 className="heading-7">What's Not</h2>
                        </div>
                        <div className="text-weight-bold">
                          {data.exclusions &&
                            data.exclusions !== "Any additional orders" ? (
                            <>{data.exclusions}</>
                          ) : (
                            <>No additional orders</>
                          )}

                          <br />
                        </div>
                      </div>
                    </div>
                    <div
                      id="w-node-_055cdd77-ca91-c72e-3006-56f5f4b8a31c-a79a8c84"
                      className="site_right-item"
                    >
                      <div className="card_content-block">
                        <div className="card-flex-block">
                          <div className="night-price-text">
                            {appliedCoupon ? (
                              <>
                                <span style={{ textDecoration: 'line-through', color: '#999' }}>
                                  ₹ {data?.price}
                                </span>
                                <span className="price-text" style={{ color: '#e2b760', marginLeft: '8px' }}>
                                  ₹ {discountedPrice}
                                </span>
                                / per seat
                                <div style={{ fontSize: '12px', color: '#28a745', marginTop: '4px' }}>
                                  Coupon "{appliedCoupon.code}" applied! 
                                  <button 
                                    onClick={removeCoupon}
                                    style={{ 
                                      marginLeft: '8px', 
                                      background: 'none', 
                                      border: 'none', 
                                      color: '#dc3545', 
                                      cursor: 'pointer',
                                      textDecoration: 'underline',
                                      fontSize: '12px'
                                    }}
                                  >
                                    Remove
                                  </button>
                                </div>
                              </>
                            ) : (
                              <>
                                <span className="price-text">₹ {data?.price} </span>
                                / per seat
                              </>
                            )}
                          </div>
                          {data?.max_seats - data?.booked_seats < 4 && (
                            <div className="night-price-text flex gap-1 items-center">
                              {/* <IconName />{" "} */}
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                className="icon icon-tabler icons-tabler-outline icon-tabler-alert-square-rounded"
                              >
                                <path
                                  stroke="none"
                                  d="M0 0h24v24H0z"
                                  fill="none"
                                />
                                <path d="M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z" />
                                <path d="M12 8v4" />
                                <path d="M12 16h.01" />
                              </svg>{" "}
                              {data?.max_seats - data?.booked_seats} seats left
                            </div>
                          )}
                        </div>
                        <div className="time-flex-block">
                          <>
                            <div className="time-flex-item">
                              <div className="dropdown-text flex items-center space-x-2">
                                <MdPeopleAlt color="#E2B760" size={20} />
                                <div className="flex flex-col">
                                  <span className="text-span-2">Guests</span>
                                  <span>1 guest</span>
                                </div>
                              </div>
                            </div>
                          </>

                          <div className="time-flex-item2">
                            <div className="embed-code-location w-embed">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                x="0px"
                                y="0px"
                                width={20}
                                height={20}
                                viewBox="0,0,256,256"
                              >
                                <g
                                  fill="currentColor"
                                  fillRule="nonzero"
                                  stroke="none"
                                  strokeWidth={1}
                                  strokeLinecap="butt"
                                  strokeLinejoin="miter"
                                  strokeMiterlimit={10}
                                  strokeDasharray=""
                                  strokeDashoffset={0}
                                  fontFamily="none"
                                  fontWeight="none"
                                  fontSize="none"
                                  textAnchor="none"
                                  style={{ mixBlendMode: "normal" }}
                                >
                                  <g transform="scale(5.33333,5.33333)">
                                    <path d="M24,4c-9.374,0 -17,7.626 -17,17c0,4.036 1.449,7.953 4.093,11.048c0.302,0.343 7.427,8.439 9.807,10.708c0.869,0.829 1.984,1.244 3.1,1.244c1.116,0 2.231,-0.415 3.101,-1.244c2.767,-2.639 9.524,-10.385 9.82,-10.725c2.63,-3.078 4.079,-6.995 4.079,-11.031c0,-9.374 -7.626,-17 -17,-17zM24,26c-2.761,0 -5,-2.239 -5,-5c0,-2.761 2.239,-5 5,-5c2.761,0 5,2.239 5,5c0,2.761 -2.239,5 -5,5z" />
                                  </g>
                                </g>
                              </svg>
                            </div>
                            <div className="time-text">
                              <span className="text-span-2">Location</span>
                              <br />
                              {data?.city ? <>{data?.city}</> : <>Bangalore</>}
                            </div>
                          </div>
                        </div>

                        <div className="card-dropdown-toggle">
                          <div className="code-embed-date-icon w-embed flex items-center space-x-2">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              x="0px"
                              y="0px"
                              width={20}
                              height={20}
                              viewBox="0,0,256,256"
                            >
                              <g
                                fill="currentColor"
                                fillRule="nonzero"
                                stroke="none"
                                strokeWidth={1}
                                strokeLinecap="butt"
                                strokeLinejoin="miter"
                                strokeMiterlimit={10}
                                strokeDasharray=""
                                strokeDashoffset={0}
                                fontFamily="none"
                                fontWeight="none"
                                fontSize="none"
                                textAnchor="none"
                                style={{ mixBlendMode: "normal" }}
                              >
                                <g transform="scale(5.33333,5.33333)">
                                  <path d="M42,14v-1.5c0,-3.584 -2.916,-6.5 -6.5,-6.5h-23c-3.584,0 -6.5,2.916 -6.5,6.5v1.5zM6,17v18.5c0,3.584 2.916,6.5 6.5,6.5h23c3.584,0 6.5,-2.916 6.5,-6.5v-18.5zM15.5,36c-1.381,0 -2.5,-1.119 -2.5,-2.5c0,-1.381 1.119,-2.5 2.5,-2.5c1.381,0 2.5,1.119 2.5,2.5c0,1.381 -1.119,2.5 -2.5,2.5zM15.5,27c-1.381,0 -2.5,-1.119 -2.5,-2.5c0,-1.381 1.119,-2.5 2.5,-2.5c1.381,0 2.5,1.119 2.5,2.5c0,1.381 -1.119,2.5 -2.5,2.5zM24,36c-1.381,0 -2.5,-1.119 -2.5,-2.5c0,-1.381 1.119,-2.5 2.5,-2.5c1.381,0 2.5,1.119 2.5,2.5c0,1.381 -1.119,2.5 -2.5,2.5zM24,27c-1.381,0 -2.5,-1.119 -2.5,-2.5c0,-1.381 1.119,-2.5 2.5,-2.5c1.381,0 2.5,1.119 2.5,2.5c0,1.381 -1.119,2.5 -2.5,2.5zM32.5,27c-1.381,0 -2.5,-1.119 -2.5,-2.5c0,-1.381 1.119,-2.5 2.5,-2.5c1.381,0 2.5,1.119 2.5,2.5c0,1.381 -1.119,2.5 -2.5,2.5z" />
                                </g>
                              </g>
                            </svg>

                            <div className="time-text">
                              <span
                                className="text-span-2"
                                style={{ marginLeft: "8px" }}
                              >
                                Date
                              </span>
                              <br />
                              <div className="badge-day">
                                {getDay(data?.event_date)
                                  ?.toUpperCase()
                                  ?.slice(0, 3)}
                              </div>
                              {formatDate(data?.event_date)} -{" "}
                              {addHour(data?.event_date, 2)}
                              { }
                            </div>
                          </div>
                        </div>

                        <div
                          onClick={() => setShowCancellation(!showCancellation)}
                          style={{
                            color: 'blue',
                            cursor: 'pointer',
                            textDecoration: 'underline',
                            marginTop: '16px',
                            maxWidth: 'fit-content',
                          }}
                        >
                          * Cancellation Policy click here to know more...
                        </div>

                        {showCancellation && (
                          <div style={{
                            marginTop: '8px',
                            padding: '4px',
                            border: '1px solid blue',
                            borderRadius: '4px',
                            boxShadow: '0 2px 6px rgba(37, 174, 233, 0.2)',
                          }}>
                            <ul>
                              <li>•	Cancellations made up to 24 hours before the event: 100% refund (excluding payment transaction fee)</li>
                              <li>•	Cancellations made within 24 hours of the event: No refund</li>
                              <li>•	In case the event is cancelled by the host/venue, guests will receive a full refund (including payment transaction fee)</li>
                              <li>•	No-shows will not be eligible for a refund.</li>
                              <li>•	Refunds will be processed to the original payment method within 5–7 business days.</li>
                            </ul>
                          </div>
                        )}

                        {/* Coupon Code Section */}
                        {accessToken && !appliedCoupon && (
                          <div className="margin-top margin-small">
                            <button 
                              className={`button-2 w-button ${disableBooking ? "disabled" : ""}`}
                              onClick={() => setShowCouponModal(true)}
                              disabled={disableBooking}
                              style={{ marginBottom: '10px', backgroundColor: '#e2b760' }}
                            >
                              Enter Coupon Code
                            </button>
                          </div>
                        )}

                        {accessToken ? (
                          <>
                            {isBooked ? (
                              <div>
                                <div
                                  className="margin-top margin-small"
                                  onClick={() => setIsModalOpen(true)}
                                >
                                  <a className="button-2 w-button">
                                    View Your Ticket
                                  </a>
                                </div>

                                <div style={{ marginTop: '6px' }}>
                                  <button
                                    className="button-cancellation w-button"
                                    onClick={() => {
                                      if (cancellationAvailable) {
                                        handleCancellation(data?.event_date);
                                      }
                                    }}
                                    disabled={!cancellationAvailable}
                                  >
                                    {cancellationAvailable ? 'Cancel Booking' : 'Cancellation time over!'}
                                  </button>
                                </div>
                              </div>
                            ) : data?.booking_close ? (
                              <div className="margin-top margin-small">
                                <div className="button-red  w-button-red ">
                                  Sold out
                                </div>
                              </div>
                            ) : isPayed ? (
                              <div
                                onClick={
                                  !disableBooking
                                    ? () => {
                                      data?.order_id
                                        ? handlePayment(data?.order_id)
                                        : handleBookTable();
                                    }
                                    : undefined
                                }
                                className="margin-top margin-small"
                              >
                                <button
                                  className={`button-2 w-button ${disableBooking ? "disabled" : ""
                                    }`}
                                  disabled={disableBooking}
                                >
                                  {disableBooking ? "Table Expired" : discountedPrice === 0 ? "Book for Free" : "Pay Now"}
                                </button>

                              </div>
                            ) : Number(userId) !==
                              Number(data?.creator_details?.id) ? (
                              <div
                                className="margin-top margin-small"
                                onClick={
                                  !disableBooking ? handleBookTable : undefined
                                }
                              >
                                <button
                                  className={`button-2 w-button ${disableBooking ? "disabled" : ""
                                    }`}
                                  disabled={disableBooking}
                                >
                                  {disableBooking
                                    ? "Table Expired"
                                    : discountedPrice === 0 ? "Book for Free" : "Book Now"}
                                </button>
                              </div>
                            ) : null}
                          </>
                        ) : (
                          <>
                            <div
                              className="margin-top margin-small"
                              onClick={
                                !disableBooking
                                  ? () => {
                                    setLoginModal(true);
                                  }
                                  : undefined
                              }
                            >

                              <button 
                                className={`button-2 w-button bg-white font-black ${disableBooking ? "disabled" : ""}`}
                                onClick={() => setLoginModal(true)}
                                disabled={disableBooking}
                                style={{ marginBottom: '10px' }}
                              >
                                Have a coupon? Login to redeem it
                              </button>

                              <button
                                className={`button-2 w-button ${disableBooking ? "disabled" : ""
                                  }`}
                                disabled={disableBooking}
                              >
                                {disableBooking
                                  ? "Table Expired"
                                  : discountedPrice === 0 ? "Book for Free" : "Book Table"}
                              </button>
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="site_content-divider" />
                  <div
                    data-w-id="055cdd77-ca91-c72e-3006-56f5f4b8a3ec"
                    className="site_map-content"
                  >
                    <div className="margin-bottom margin-small">
                      <h2 className="heading-7">Where you’ll be</h2>
                    </div>
                    {accessToken && isPayed ? (
                      <div className="map-block">
                        <div className="map-embed w-embed w-iframe">
                          <div className="mapouter">
                            <div className="gmap_canvas">
                              <iframe
                                className="gmap_iframe"
                                width="100%"
                                frameBorder={0}
                                scrolling="no"
                                marginHeight={0}
                                marginWidth={0}
                                src={`https://maps.google.com/maps?width=772&height=440&hl=en&q=${data?.location?.lat},${data?.location?.lng}&t=&z=12&ie=UTF8&iwloc=B&output=embed`}
                              />

                              <a href="https://kokagames.com/">HighTable</a>
                            </div>
                            <style
                              dangerouslySetInnerHTML={{
                                __html:
                                  "\n                          .mapouter {\n                            position: relative;\n                            text-align: right;\n                            width: 100%;\n                            height: 440px;\n                          }\n                          .gmap_canvas {\n                            overflow: hidden;\n                            background: none !important;\n                            width: 100%;\n                            height: 440px;\n                          }\n                          .gmap_iframe {\n                            height: 440px !important;\n                          }\n                        ",
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    ) : (
                      <AreaMap data={data} />
                    )}
                    <div className="map_content-wrap">
                      <div className="margin-top margin-medium">
                        <h6 className="heading-6">{data?.address}</h6>
                      </div>
                    </div>
                  </div>
                  <div className="site_content-divider" />
                  <div
                    data-w-id="055cdd77-ca91-c72e-3006-56f5f4b8a3ff"
                    className="site_review-details"
                  >
                    <div className="review_details-left-item">
                      <div className="review_details-flex-item">
                        <Link
                          to={`/viewprofile?user=${data?.creator_details?.first_name}&id=${data?.creator_details?.id}`}
                          className="review-five-user"
                        >
                          <img
                            src={
                              data?.creator_details?.photo
                                ? `https://s3.ap-south-1.amazonaws.com/high-table-2024/public/photo/members/${data?.creator_details?.photo}`
                                : "../../static/media/user-icon-1.62f73db9586c0e3b573a.svg"
                            }
                            loading="lazy"
                            alt=""
                            className="user-profile-pic"
                          />
                        </Link>
                        <div className="review_details-content">
                          <div className="margin-bottom margin-xxsmall">
                            <h6 className="heading-6">
                              Hosted by {data?.creator_details?.first_name}
                            </h6>
                          </div>
                          <div className="margin-bottom">
                            <div className="date-text">
                              {data?.creator_details?.gender && (
                                <>{data?.creator_details?.gender} </>
                              )}
                              {/* {data?.creator_details.age > 0 ? (
                                <>{data?.creator_details.age} Years Old</>
                              ) : (
                                <>Forever a mystery</>
                              )} */}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="rating-table-count-flex">
                        {/* <div
                          data-w-id="377d957f-7a88-d9bc-c656-abf8afdb6dc7"
                          className="review-block-big"
                        >
                          <div className="code-embed-7 w-embed">
                            <svg
                              height="auto"
                              width="100%"
                              version="1.1"
                              xmlns="http://www.w3.org/2000/svg"
                              xmlnsXlink="http://www.w3.org/1999/xlink"
                              viewBox="0 0 47.94 47.94"
                              xmlSpace="preserve"
                            >
                              <path
                                fill="currentColor"
                                d="M26.285,2.486l5.407,10.956c0.376,0.762,1.103,1.29,1.944,1.412l12.091,1.757
	c2.118,0.308,2.963,2.91,1.431,4.403l-8.749,8.528c-0.608,0.593-0.886,1.448-0.742,2.285l2.065,12.042
	c0.362,2.109-1.852,3.717-3.746,2.722l-10.814-5.685c-0.752-0.395-1.651-0.395-2.403,0l-10.814,5.685
	c-1.894,0.996-4.108-0.613-3.746-2.722l2.065-12.042c0.144-0.837-0.134-1.692-0.742-2.285l-8.749-8.528
	c-1.532-1.494-0.687-4.096,1.431-4.403l12.091-1.757c0.841-0.122,1.568-0.65,1.944-1.412l5.407-10.956
	C22.602,0.567,25.338,0.567,26.285,2.486z"
                              />
                            </svg>
                          </div>
                          <div className="review-text-increase">
                            {data?.creator_details?.reviews > 0 ? (
                              <> {data?.creator_details?.reviews}</>
                            ) : (
                              <>No reviews</>
                            )}
                          </div>
                        </div> */}
                        <div
                          data-w-id="e1c50a13-9747-3145-0339-dfa7051f7b28"
                          className="review-block-big"
                        >
                          <div className="code-embed-7 w-embed">
                            {/*?xml version="1.0" encoding="utf-8"?*/}
                            {/*  Uploaded to: SVG Repo, www.svgrepo.com, Generator: SVG Repo Mixer Tools  */}
                            <svg
                              width="100%"
                              height="auto"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <rect width={24} height={24} fill="white" />
                              <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M5 9.5C5 7.01472 7.01472 5 9.5 5C11.9853 5 14 7.01472 14 9.5C14 11.9853 11.9853 14 9.5 14C7.01472 14 5 11.9853 5 9.5Z"
                                fill="currentColor"
                              />
                              <path
                                d="M14.3675 12.0632C14.322 12.1494 14.3413 12.2569 14.4196 12.3149C15.0012 12.7454 15.7209 13 16.5 13C18.433 13 20 11.433 20 9.5C20 7.567 18.433 6 16.5 6C15.7209 6 15.0012 6.2546 14.4196 6.68513C14.3413 6.74313 14.322 6.85058 14.3675 6.93679C14.7714 7.70219 15 8.5744 15 9.5C15 10.4256 14.7714 11.2978 14.3675 12.0632Z"
                                fill="currentColor"
                              />
                              <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M4.64115 15.6993C5.87351 15.1644 7.49045 15 9.49995 15C11.5112 15 13.1293 15.1647 14.3621 15.7008C15.705 16.2847 16.5212 17.2793 16.949 18.6836C17.1495 19.3418 16.6551 20 15.9738 20H3.02801C2.34589 20 1.85045 19.3408 2.05157 18.6814C2.47994 17.2769 3.29738 16.2826 4.64115 15.6993Z"
                                fill="currentColor"
                              />
                              <path
                                d="M14.8185 14.0364C14.4045 14.0621 14.3802 14.6183 14.7606 14.7837V14.7837C15.803 15.237 16.5879 15.9043 17.1508 16.756C17.6127 17.4549 18.33 18 19.1677 18H20.9483C21.6555 18 22.1715 17.2973 21.9227 16.6108C21.9084 16.5713 21.8935 16.5321 21.8781 16.4932C21.5357 15.6286 20.9488 14.9921 20.0798 14.5864C19.2639 14.2055 18.2425 14.0483 17.0392 14.0008L17.0194 14H16.9997C16.2909 14 15.5506 13.9909 14.8185 14.0364Z"
                                fill="currentColor"
                              />
                            </svg>
                          </div>
                          <div className="review-text-increase">
                            {data?.creator_details?.table_count}{" "}
                            <a className="review-link">
                              {data?.creator_details?.table_count > 0 ? (
                                <>Tables Hosted</>
                              ) : (
                                <>Table Hosted</>
                              )}
                            </a>
                          </div>
                        </div>
                      </div>
                      <div className="margin-top margin-medium">
                        <p className="paragraph-2">
                          {data?.creator_details?.about_me}{" "}
                        </p>
                      </div>
                      <div className="margin-bottom margin-small view-profile-btn">
                        <Link
                          to={`/viewprofile?user=${data?.creator_details?.first_name}&id=${data?.creator_details?.id}`}
                          className="button-3 w-button"
                        >
                          View Profile
                        </Link>
                      </div>
                    </div>
                    <div id="w-node-_055cdd77-ca91-c72e-3006-56f5f4b8a42f-a79a8c84">
                      <h6 className="heading-6">Support</h6>
                      <div className="protection-div-flex magrin-top-1rem">
                        <div className="text-block-12">
                          To protect your payment, never transfer
                          <br />
                          money or communicate outside of the
                          <br />
                          HighTable website or app.
                        </div>
                      </div>
                      <div className="report-div magrin-top-1rem">
                        <ReportTable tableId={data?.id} />
                        {/* <a href="#" className="report-btn w-button">
                          Report User
                        </a> */}
                      </div>
                    </div>
                  </div>
                  <div className="site_content-divider" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section >

      <OpenEmail
        showModal={showModal}
        setShowModal={setShowModal}
        setEmail={setEmail}
        email={email}
        age={age}
        setAge={setAge}
        gender={gender}
        setGender={setGender}
        userName={userName}
        setUserName={setUserName}
        handleBookTable={() =>
          isPayed ? handlePayment(data?.order_id) : handleBookTable()
        }
      />
      {
        thanksModal && (
          <ThankYou
            onClose={() => setThanksModal(false)}
            tname={tname}
            price={discountedPrice || data?.price}
          />
        )
      }
      
      {/* Coupon Code Modal */}
      {showCouponModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 w-96 max-w-md mx-4">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-xl font-bold text-gray-800">Enter Coupon Code</h2>
              <button
                onClick={() => {
                  setShowCouponModal(false);
                  setCouponCode('');
                  setCouponError('');
                }}
                className="text-gray-500 hover:text-gray-700 text-2xl"
              >
                ×
              </button>
            </div>
            
            <div className="mb-4">
              <label htmlFor="couponCode" className="block text-sm font-medium text-gray-700 mb-2">
                Coupon Code
              </label>
              <input
                type="text"
                id="couponCode"
                value={couponCode}
                onChange={(e) => {
                  setCouponCode(e.target.value);
                  if (couponError) setCouponError('');
                }}
                placeholder="Enter your coupon code"
                className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 ${
                  couponError 
                    ? 'border-red-500 focus:ring-red-500 focus:border-red-500' 
                    : 'border-gray-300 focus:ring-blue-500 focus:border-blue-500'
                }`}
                disabled={couponLoading}
              />
              {couponError && (
                <p className="mt-1 text-sm text-red-600">{couponError}</p>
              )}
            </div>
            
            <div className="flex gap-3">
              <button
                onClick={() => {
                  setShowCouponModal(false);
                  setCouponCode('');
                  setCouponError('');
                }}
                className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50 transition-colors"
                disabled={couponLoading}
              >
                Cancel
              </button>
              <button
                onClick={validateCoupon}
                className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors disabled:opacity-50"
                style={{ backgroundColor: '#e2b760' }}
                disabled={couponLoading || !couponCode.trim()}
              >
                {couponLoading ? 'Validating...' : 'Apply Coupon'}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ListeningDetails;
